import { Alert, Box, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useRecentCommandHistory } from '@src/api/dev-tools-history-api'
import { DevToolsCommandType } from '@src/types/dev-tools'
import { useTranslation } from 'react-i18next'
import { useCommandHistoryColumns } from './CommandHistoryColumns'

interface CommandRecentExecutionsTableProps {
  commandType: DevToolsCommandType
}

const RECENT_EXECUTIONS_LIMIT = 5

const CommandRecentExecutionsTable = ({ commandType }: CommandRecentExecutionsTableProps) => {
  const { t } = useTranslation()
  const columns = useCommandHistoryColumns({ includeErrorMessage: false })
  const { data, isLoading, isError } = useRecentCommandHistory(commandType, RECENT_EXECUTIONS_LIMIT)

  const rows = data ?? []

  if (isError) {
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="error">{t('admin.devTools.history.loadError')}</Alert>
      </Box>
    )
  }

  if (!isLoading && rows.length === 0) {
    return (
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {t('admin.devTools.history.empty')}
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        hideFooter
        disableColumnFilter
        disableColumnSelector
        disableRowSelectionOnClick
        density="compact"
        sx={{
          minHeight: 220,
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
        }}
      />
    </Box>
  )
}

export default CommandRecentExecutionsTable
